export const URL_PATTERN = /^(https?:\/\/)((?:[^./\s]+\.)+[^./\s]+)(\/[^?#]*)?(\?[^#]*)?(#.*)?$/
